import React from 'react'
import { useSelector } from 'react-redux'

import GridElementContainer from '../../GridElementContainer'
import Avatar from '../../../../../UI/Avatar'

import { selectUserData } from '../../../../../../routing/fetchingfunction/user/user.reducer'

import { useUserName } from '../../../../../../hooks'

import { getAvatarUrl } from '../../../../../../helpers'

const MyProfileStudent = ({ containerClassName = '', className = '' }) => {
  const userData = useSelector(selectUserData)

  // Get username with the now-safe hook
  const userName = useUserName()

  // Handle the case when userData is null
  if (!userData) {
    return (
      <GridElementContainer className={containerClassName} title="My Profile">
        <div
          className={`relative p-[10px] rounded-md !border border-primary-450 w-full flex flex-col items-center justify-between h-full ${className}`}
        >
          <div className="w-12 h-12 !mb-3">
            <Avatar src={null} gender="neutral" className="w-full h-full block" />
          </div>
          <p className="text-center text-primary-100 font-semibold !mb-0">Loading profile...</p>
        </div>
      </GridElementContainer>
    )
  }

  return (
    <GridElementContainer className={containerClassName} title="My Profile">
      <div
        className={`relative p-[10px] rounded-md !border border-primary-450 w-full flex flex-col items-center justify-between h-full ${className}`}
      >
        {/*<span className="absolute left-[10px] top-[10px] bg-primary-500 !border border-[#F9E0CD] rounded-[4px] text-primary-100 !py-1 !px-2">*/}
        {/*  Student*/}
        {/*</span>*/}

        <div className="w-12 h-12 !mb-3">
          <Avatar
            src={getAvatarUrl(userData?.user_student_profile?.profile_picture)}
            gender={userData?.profile?.gender || 'neutral'}
            className="w-full h-full block"
          />
        </div>

        {userData?.user_student_profile && (
          <h3 className="text-primary-100 text-sm font-bold mb-3 text-center">{userName}</h3>
        )}

        <div className="flex items-center justify-center gap-x-[2px] !mb-3">
          <img src="/assets/icon/orangeTrueIcon.png" alt="checkmark" />
          <img src="/assets/icon/orangeTrueIcon.png" alt="checkmark" />
          <img src="/assets/icon/orangeTrueIcon.png" alt="checkmark" />
          <img src="/assets/icon/orangeTrueIcon.png" alt="checkmark" />
          <img src="/assets/icon/orangeTrueIcon.png" alt="checkmark" />
          <img src="/assets/icon/orangeTrueIcon.png" alt="checkmark" />
        </div>

        <div className="grid grid-rows-1 grid-cols-3 gap-x-2 w-full">
          <div className="!py-1 bg-primary-500 flex flex-col items-center justify-center">
            <h4 className="text-primary-75 text-xs font-medium">Days in Apolo</h4>
            <span className="text-primary-100 font-bold">95</span>
          </div>
          <div className="!py-1 bg-primary-500 flex flex-col items-center justify-center">
            <h4 className="text-primary-75 text-xs font-medium">Total Classes</h4>
            <span className="text-primary-100 font-bold">30</span>
          </div>
          <div className="!py-1 bg-primary-500 flex flex-col items-center justify-center">
            <h4 className="text-primary-75 text-xs font-medium">Total Tutors</h4>
            <span className="text-primary-100 font-bold">15</span>
          </div>
        </div>
      </div>
    </GridElementContainer>
  )
}

export default MyProfileStudent
